import React from 'react';
import { FaPlus } from 'react-icons/fa';

const PageHeader = ({ title, onCreate, createLabel = 'Create New' }) => (
  <div className="flex justify-between items-center mb-4">
    <h1 className="text-2xl font-semibold">{title}</h1>
    {onCreate && (
      <button
        className="flex items-center px-4 py-2 bg-black text-white rounded-md shadow-sm hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-indigo-500"
        onClick={onCreate}
      >
        <FaPlus className="mr-2" /> {createLabel}
      </button>
    )}
  </div>
);

export default PageHeader;
